var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H16.3704V2.51852H0V0ZM0 5.03704H16.3704V7.55556H0V5.03704ZM6.92578 10.0741H0V12.5926H6.92578V10.0741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4937 10.2558C18.7631 10.0163 18.7631 9.59517 18.4937 9.35563C18.2655 9.15281 17.9217 9.15281 17.6935 9.35563L15.1644 11.6037C14.7855 11.9405 14.2145 11.9405 13.8356 11.6037L11.3065 9.35563C11.0783 9.15281 10.7345 9.15281 10.5063 9.35563C10.2369 9.59517 10.2369 10.0163 10.5063 10.2558L12.7527 12.2526C13.2003 12.6504 13.2003 13.3496 12.7527 13.7474L10.5063 15.7442C10.2369 15.9837 10.2369 16.4048 10.5063 16.6444C10.7345 16.8472 11.0783 16.8472 11.3065 16.6444L13.8356 14.3963C14.2145 14.0595 14.7855 14.0595 15.1644 14.3963L17.6935 16.6444C17.9217 16.8472 18.2655 16.8472 18.4937 16.6444C18.7631 16.4048 18.7631 15.9837 18.4937 15.7442L16.2473 13.7474C15.7997 13.3496 15.7997 12.6504 16.2473 12.2526L18.4937 10.2558Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveData);
export default __webpack_public_path__ + "static/media/removeData.184e88f58537633acd0ba56006b294fb.svg";
export { ForwardRef as ReactComponent };